import { render } from "./IconPerson.vue?vue&type=template&id=0492a5b4&ts=true"
import script from "./IconPerson.vue?vue&type=script&lang=ts"
export * from "./IconPerson.vue?vue&type=script&lang=ts"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__